import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { object, array, bool, string } from "prop-types";

import { getHeadline, getExcerpt, checkCurrentStoryTagForSpecialCampaign } from "../../../utils/utils";

import CardImage from "../../../atoms/CardImage";
import NewsHeadline from "../../../atoms/NewsHeadline";
import LiveNewsHeadline from "../../../atoms/liveNewsHeadline";
import Excerpt from "../../../atoms/Excerpt";
import SectionHolder from "../../../atoms/SectionHolder";
import SponsorDetails from "../../../molecules/SponsorDetails";

import "./organism1.m.css";

const Organism1 = ({
  story,
  showHeroImage = true,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  darkTheme = false,
  largeIcon = false,
  sectionData,
  showSectionTag,
  selectedTagName,
  headlineSpecialColor,
}) => {
  const { subheadline } = story;
  const storyHeadline = getHeadline(story);
  const excerpt = getExcerpt(story);
  const currentStoryTitleColor = checkCurrentStoryTagForSpecialCampaign(story, selectedTagName, headlineSpecialColor);
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";

  const imageCaption = () => {
    if (get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"])) {
      return get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"]);
    } else if (
      !get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) &&
      get(story, ["hero-image-caption"])
    ) {
      return get(story, ["hero-image-caption"]);
    } else return null;
  };

  const imageAttribute = () => {
    if (get(story, ["alternative", "home", "default", "hero-image", "hero-image-attribution"])) {
      return get(story, ["alternative", "home", "default", "hero-image", "hero-image-attribution"]);
    } else if (
      !get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) &&
      get(story, ["hero-image-attribution"])
    ) {
      return get(story, ["hero-image-attribution"]);
    } else return null;
  };

  let heroImage = "";

  if (get(story, ["alternative", "home", "default", "hero-image"])) {
    heroImage = story.alternative.home.default["hero-image"]["hero-image-s3-key"]
      ? story.alternative.home.default["hero-image"]["hero-image-s3-key"]
      : story.alternative.home.default["hero-image"].key
      ? story.alternative.home.default["hero-image"].key
      : "";
  } else if (story["hero-image-s3-key"]) {
    heroImage = story["hero-image-s3-key"];
  }
  return (
    <div styleName={`news_item lead_story ${heroImage ? "" : "no-image"}`}>
      <div styleName="photo">
        {showHeroImage && (
          <Link href={story.url}>
            <CardImage
              story={story}
              aspectRatio={aspectRatio}
              imageType={imageType}
              widths={widths}
              showAlternateImage={true}
              darkTheme={darkTheme}
              largeIcon={largeIcon}
              datatrackingcategory="Component One"
              datatrackingaction="Click"
              datatrackinglabel="Position-1 image-view"
              datatrackingsubcategory="Component One Story Click"
            />
          </Link>
        )}
        <div styleName="caption">
          {imageCaption() && <span>{imageCaption()}</span>}
          {imageAttribute() && <span> | {imageAttribute()}</span>}
        </div>
      </div>
      <div styleName="text">
        {showLiveBlog ? (
          <LiveNewsHeadline
            titleText={storyHeadline}
            titleLink={story.url}
            story={story}
            cssStyleName="bigSize"
            datatrackingcategory="Component One"
            datatrackingaction="Click"
            datatrackinglabel="Position-1"
            datatrackingsubcategory="Component One Story Click"
          />
        ) : (
          <NewsHeadline
            titleText={storyHeadline}
            titleLink={story.url}
            subHeadlineText={subheadline}
            cssStyleName="bigSize"
            datatrackingcategory="Component One"
            datatrackingaction="Click"
            datatrackinglabel="Position-1"
            datatrackingsubcategory="Component One Story Click"
            currentStoryTitleColor={currentStoryTitleColor}
            story={story}
          />
        )}
        <Excerpt
          excerpt={excerpt}
          excerptLink={story.url}
          datatrackingcategory="Component One"
          datatrackingaction="Click"
          datatrackinglabel="Position-1"
        />
        {sponsorId ? (
          <SponsorDetails sponsorId={sponsorId} showImage={false} />
        ) : sectionData ? (
          <SectionHolder sectionData={sectionData} story={story} showSectionTag={showSectionTag} />
        ) : null}
      </div>
    </div>
  );
};

Organism1.propTypes = {
  story: object.isRequired,
  showHeroImage: bool,
  aspectRatio: array,
  imageType: string,
  widths: array,
  darkTheme: bool,
  largeIcon: bool,
  sectionData: object,
  showSectionTag: bool,
  selectedTagName: string,
  headlineSpecialColor: string,
};

export default Organism1;
